import React from 'react';
import { connect } from 'dva';
import SysConfig from '../components/login/SysConfig';
import { injectIntl } from 'react-intl';

export default connect(state => {
  return {
    ...state,
    loading: state.loading.global
  };
})(
  injectIntl(({ loading, intl, dispatch }) => {
    return <SysConfig intl={intl} loading={loading} dispatch={dispatch} />;
  })
);



// WEBPACK FOOTER //
// ./src/routes/SysConfig.js